export default "__VITE_ASSET__DGEJlDeR__"